'use strict';
;(function($, window, document){

	// ----------------------------------- Start : Setting
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws;

	// 取得Window設定值
	var windowSetting = function(){
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}
	windowSetting();
	registerListener('resize', windowSetting);

	// 取得裝置判斷
	// isMobile 判斷
	var isMobile = false;
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
		isMobile = true
	}

	var isPhone = ww <= 639;
	var isTable = ww <= 1023;
	// ----------------------------------- End : Setting

	


	// ------------------------------------------ Start: Swiper breakpoint Detected

	// keep track of swiper instances to destroy later
	var mySwiperItem3 = undefined;

	// ----------------------
	// Swiper breakpoint Detected
	var breakpoint_medium = window.matchMedia('(min-width:1024px)');

	var breakpointChecker_medium = function() {
		if (breakpoint_medium.matches === true) {
			if (mySwiperItem3 !== undefined) mySwiperItem3.destroy(true, true);
			return;
		} else if (breakpoint_medium.matches === false) {
			return enableSwiper_medium();
		}
	};
	
	// Add Swiper buildHandler
	var enableSwiper_medium = function() {
		buildSwiperItem3();
	};

	// keep an eye on viewport size changes
	breakpoint_medium.addListener(breakpointChecker_medium);

	// start
	registerListener('load', breakpointChecker_medium);


	// ------------------------------------------- Start : What we can do
	// Swiper Setting
	// What we can do
	function buildSwiperItem3(){
		var SwiperItem3 = '#standard-what-slider';
		var SwiperItem3BtnNext = $(SwiperItem3).children('.swiper-button-next');
		var SwiperItem3BtnPrev = $(SwiperItem3).children('.swiper-button-prev');
		
		if($(SwiperItem3).length <= 0) return false;

		mySwiperItem3 = new Swiper(SwiperItem3, {
			speed: 400,
			autoHeight: true,
			spaceBetween: 30,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: SwiperItem3BtnNext,
				prevEl: SwiperItem3BtnPrev,
			},
			breakpoints: {
				// when window width is <= 639px
				639: {
					slidesPerView: 1,
				},
				// when window width is <= 1199px
				1023: {
					slidesPerView: 'auto',
					centeredSlides: true
				}
			},
		});
	};

	// ------------------------------------------- End : What we can do



	// ------------------------------------------- Start : Scroll to hash
	// Scroll to hash
	// Ref: https://gist.github.com/srikat/10812884#file-gistfile4-js
	var hash;

	// Check Faq hash and Stop Scroll
	function checkHash(){
		// location
		hash = location.hash;
		if(hash != '' && $(hash).length > 0){

			var $el = $(hash);
			var scrollTop = $el.offset().top - $('header').innerHeight();

			// Stop wheel Scroll
			registerListener('mousewheel', stopMouseWheel);

			// 滑動到指定項目
			$('html, body').stop().animate({'scrollTop': scrollTop}, 400, function(){
				// Open wheel Scroll
				removeListener('mousewheel', stopMouseWheel);
			});
		}
	}
	checkHash();

	// Reference: http://solidlystated.com/scripting/javascript-disable-mouse-wheel/
	function stopMouseWheel(e){
		if(!e){ e = window.event; } /* IE7, IE8, Chrome, Safari */
		if(e.preventDefault) { e.preventDefault(); } /* Chrome, Safari, Firefox */
		e.returnValue = false; /* IE7, IE8 */
	}

	
	// 如果點選 主選單項目
	$(document).on('click', '#main-nav a[href*="#"]', function(e){
		if(location.origin + location.pathname === this.href.split(this.hash)[0]){
			// 同一頁
			e.preventDefault();

			// 更改歷史紀錄
			history.pushState({}, '', this.href);

			// 滑動頁面
			setTimeout(function(){
				checkHash();
			}, 10);

			// 如果是手機、平板 => 關閉選單
			if(ww < 1024){
				$('#hamburger-menu').trigger('click');
			}
		}
	})

	
	// ------------------------------------------- End : Scroll to hash
	
})(jQuery, window, document);